module.exports = __webpack_public_path__ + "img/logo.ce12630a.png";